import { combineReducers } from "redux";
import LayoutReducer from "./layouts/reducer";
import LogoReducer from "./logo/reducer";
import TokenReducer from "./token/reducer";
import UserInforReducer from "./userInfo/reducer"
// Context: tenantId, empresa, departamento,...
import ContextReducer from "./context/reducer"
import LegacyEmpresasReducer from "./legacyEmpresas/reducer"
import LegacyDepartamentosReducer from "./legacyDepartamentos/reducer"
import LegacyPatentesReducer from "./legacyPatentes/reducer"
import LegacyMarcasReducer from "./legacyMarcas/reducer"
import LegacyPersonasReducer from "./legacyPersonas/reducer"
import LegacyModelosReducer from "./legacyModelos/reducer"
import LegacyColoresReducer from "./legacyColores/reducer"
import LegacyTiposCombustibleReducer from "./legacyTiposCombustible/reducer"
import LegacyTiposTraccionReducer from "./legacyTiposTraccion/reducer"
import LegacyTiposTransmisionReducer from "./legacyTiposTransmision/reducer"
import LegacyTiposTrabajoOtReducer from "./legacyTiposTrabajoOt/reducer"
import LegacyRegionesReducer from "./legacyRegiones/reducer"
import LegacyCiudadesReducer from "./legacyCiudades/reducer"
import LegacyComunasReducer from "./legacyComunas/reducer"
import RecepcionVehiculosReducer from "./recepcionVehiculos/reducer"

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Logo: LogoReducer,
    Token: TokenReducer,
    UserInfo: UserInforReducer,
    Context: ContextReducer,
    LegacyEmpresas: LegacyEmpresasReducer,
    LegacyDepartamentos: LegacyDepartamentosReducer,
    LegacyPatentes: LegacyPatentesReducer,
    LegacyPersonas: LegacyPersonasReducer,
    LegacyMarcas: LegacyMarcasReducer,
    LegacyModelos: LegacyModelosReducer,
    LegacyColores: LegacyColoresReducer,
    LegacyTiposCombustible: LegacyTiposCombustibleReducer,
    LegacyTiposTraccion: LegacyTiposTraccionReducer,
    LegacyTiposTransmision: LegacyTiposTransmisionReducer,
    LegacyTiposTrabajoOt: LegacyTiposTrabajoOtReducer,
    LegacyRegiones: LegacyRegionesReducer,
    LegacyCiudades: LegacyCiudadesReducer,
    LegacyComunas: LegacyComunasReducer,
    
    RecepcionVehiculos: RecepcionVehiculosReducer
});

export default rootReducer;